





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CustomerCamera } from '../../types/customerInfo';
import { CustomerInfoResponse } from '../../types/surelockResponses';

@Component
export default class CustomerInfo extends Vue {
    @Prop() custInfo!: CustomerInfoResponse;

    displayExtendedAddress(): string {
      if (!this.custInfo?.subscription) {
        return '';
      }

      const { city, state, zip, country } = this.custInfo.subscription.location;
      return `${city}, ${state} ${zip} ${country}`;
    }

    populateUuids(): void {
      const uuids = this.custInfo?.cameras?.map((c: CustomerCamera) => c.uuid);
      this.$emit('fillUuids', uuids);
    }
}
